import { ApolloClient } from "@apollo/client";
import RootStore from "./RootStore";

const createStores = (apolloClient: ApolloClient<any>) => {
  return new RootStore(apolloClient);
};

export default createStores;
